<div class="editable-field-wrapper" id="wrapper" [class.disabled]="disabled">
  <div [class.editable-content]="!href">
    <div class="content-row">
      <span (click)="handleContentClick($event)" [class.clickable]="href && !linkDisabled">
        <ng-content></ng-content>
      </span>
      <mat-icon *ngIf="!disabled" class="edit-icon" (click)="handleClick($event)">edit</mat-icon>
    </div>
  </div>

  <div *ngIf="isDialogOpen && showCustomContent" class="edit-dialog" id="dialog" tabindex="0" [style.top.px]="dialogPosition.top" [style.left.px]="dialogPosition.left" [style.position]="'fixed'">
    <div class="dialog-content">
      <div *ngIf="customContent" [innerHTML]="customContent"></div>

      <ng-content select="[slot=dialog-content]"></ng-content>
    </div>
  </div>
</div>
